"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDGanttPaginationComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDGanttPaginationComponent, _Mixins);

  var _super = _createSuper(LMDGanttPaginationComponent);

  function LMDGanttPaginationComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDGanttPaginationComponent);
    _this = _super.apply(this, arguments);
    _this.tCurrentPage = _this.truckCurrentPage;
    _this.tPageSize = _this.truckPageSize;
    return _this;
  }

  (0, _createClass2.default)(LMDGanttPaginationComponent, [{
    key: "onTruckFiltersChanges",
    value: function onTruckFiltersChanges(newVal, oldVal) {
      if (!this.helper.isEqual(newVal, oldVal)) {
        this.tCurrentPage = 1;
        this.handlePagination(1, 'currentChange');
      }
    }
  }, {
    key: "onIsUpdateBufferTrucksChanges",
    value: function onIsUpdateBufferTrucksChanges(newVal, oldVal) {
      if (!this.helper.isEqual(newVal, oldVal)) {
        this.tCurrentPage = 1;
        this.handlePagination(1, 'currentChange');
      }
    }
  }, {
    key: "totalTravelDistance",
    get: function get() {
      if (this.$plan && this.$plan.trucks) {
        var totalDistance = this.$plan.trucks.reduce(function (acc, val) {
          return val.estimatedDistance + acc;
        }, 0);
        return this.helper.printThousandDecimal(totalDistance / 1000) + ' km';
      }
    }
  }, {
    key: "filteredTrucks",
    get: function get() {
      var _this2 = this;

      if (!this.isFilterTruck) {
        return this.$bufferTrucks.slice(0, this.$bufferTrucks.length);
      }

      var disabledTrucks = [];

      if (window.localStorage.getItem(this.disableTruckKey)) {
        disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      var trucks = this.$bufferTrucks.filter(function (truck) {
        var bool = _this2.isValidTruck(truck) && !_this2.helper.includes(disabledTrucks, truck['id'].toString());
        var bool2 = !_this2.helper.includes(disabledTrucks, truck['id'].toString());
        return _this2.isAutoAssign ? _this2.isShowEnabledTruck ? bool : !bool : _this2.isShowEnabledTruck ? bool2 : !bool2;
      });
      return trucks.slice(0, trucks.length);
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handlePagination",
    value: function handlePagination(val, type) {
      switch (type) {
        case 'sizeChange':
          this.tPageSize = val;
          this.$emit('onTruckSizeChange', val);
          break;

        case 'currentChange':
          this.tCurrentPage = val;
          this.$emit('onTruckCurrentChange', val);
          break;
      }
    }
  }]);
  return LMDGanttPaginationComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileV.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDGanttPaginationComponent.prototype, "isFilterTruck", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDGanttPaginationComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDGanttPaginationComponent.prototype, "isShowEnabledTruck", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: {
    hasValue: false
  }
})], LMDGanttPaginationComponent.prototype, "isUpdateBufferTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 1
})], LMDGanttPaginationComponent.prototype, "truckCurrentPage", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 10
})], LMDGanttPaginationComponent.prototype, "truckPageSize", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckFilters', {
  deep: true
})], LMDGanttPaginationComponent.prototype, "onTruckFiltersChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isUpdateBufferTrucks', {
  deep: true
})], LMDGanttPaginationComponent.prototype, "onIsUpdateBufferTrucksChanges", null);
LMDGanttPaginationComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderFilterComponent',
  components: {
    'el-pagination': _elementUi.Pagination,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col
  }
})], LMDGanttPaginationComponent);
var _default = LMDGanttPaginationComponent;
exports.default = _default;